import { isDefined } from "@clipboard-health/util-ts";
import { type CbhAppInfo } from "@src/appV2/lib/index";

import {
  type HcfTimeclockComplianceRollout,
  HcfTimeclockComplianceRolloutState,
} from "../Shift/ShiftState/types";
import { isEnabledForAppVersionAndOta } from "./isSolveUnpaidBreaksFeatureEnabled";

interface IsHcfTimeclockComplianceEnabled {
  hcfTimeclockComplianceRollout?: HcfTimeclockComplianceRollout;
  appInfo?: CbhAppInfo;
}

export function checkIsHcfTimeclockComplianceEnabled(
  parameters: IsHcfTimeclockComplianceEnabled
): boolean {
  const { hcfTimeclockComplianceRollout, appInfo } = parameters;

  if (!isDefined(hcfTimeclockComplianceRollout)) {
    return false;
  }

  const { state, minimalOtaVersion, minimalStoreVersion } = hcfTimeclockComplianceRollout;

  if (state !== HcfTimeclockComplianceRolloutState.ENABLED) {
    return false;
  }

  return isEnabledForAppVersionAndOta({
    minimalOtaVersion: String(minimalOtaVersion),
    minimalStoreVersion,
    appInfo,
  });
}

export function checkIsHcfTimeclockComplianceEnabledWithVideo(
  parameters: IsHcfTimeclockComplianceEnabled
): boolean {
  const { hcfTimeclockComplianceRollout, appInfo } = parameters;

  if (!isDefined(hcfTimeclockComplianceRollout)) {
    return false;
  }

  const { state, videoMinimalVersion, useVideo } = hcfTimeclockComplianceRollout;

  if (state !== HcfTimeclockComplianceRolloutState.ENABLED || !useVideo) {
    return false;
  }

  if (!isDefined(videoMinimalVersion)) {
    return true;
  }

  return isEnabledForAppVersionAndOta({
    minimalOtaVersion: String(videoMinimalVersion.ota),
    minimalStoreVersion: videoMinimalVersion.store,
    appInfo,
  });
}
